import { Component, Input, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';

import { SummaryGrantModel } from '../../models/summary-grant.model';
import { SubventionService } from '../../../../../modules/invoice/subvention/subvention.service';
import { SubventionModel } from '../../../../../modules/invoice/subvention/subvention.model';
import {
  SubventionAmortisationModel,
  SubventionAmortisationSummary,
  summarizeAmortisation,
} from '../../../../../modules/invoice/subvention/amortisation/subvention-amortisation.model';
import { LoadingDialogService } from '../../../../../shared/ui/loading/loading-dialog.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { Utils } from '../../../../../shared/utils';

@Component({
  selector: 'app-grant-detail-tabs',
  templateUrl: './grant-detail-tabs.component.html',
  styleUrls: ['./grant-detail-tabs.component.scss'],
  standalone: false,
})
export class GrantDetailTabsComponent implements OnInit {
  @Input() row!: SummaryGrantModel;

  detail: (SubventionModel & { investmentName?: string }) | null = null;
  loadingData = true;

  amortisation: SubventionAmortisationModel[] = [];
  summary: SubventionAmortisationSummary = summarizeAmortisation([]);
  loadingAmortisation = true;
  amortisationError = false;

  get amortisedPercent(): number {
    if (!this.summary.total) return 0;
    return Math.min(100, Math.max(0, (this.summary.accumulated / this.summary.total) * 100));
  }

  constructor(
    private subventionService: SubventionService,
    private loading: LoadingDialogService,
    private notify: NotificationService,
  ) { }

  ngOnInit(): void {
    if (!this.row) return;

    this.subventionService.loadData(this.row.uid)
      .then(detail => { this.detail = detail || null; })
      .catch(() => { this.detail = null; })
      .then(() => { this.loadingData = false; });

    this.subventionService.getAmortisation(this.row.uid)
      .then(rows => {
        this.amortisation = Array.isArray(rows) ? rows : [];
        this.summary = summarizeAmortisation(this.amortisation);
      })
      .catch(() => { this.amortisationError = true; })
      .then(() => { this.loadingAmortisation = false; });
  }

  exportAmortisation(): void {
    this.loading.run('Generando Excel de amortización…', this.subventionService.export(this.row.uid))
      .then(blob => {
        FileSaver.saveAs(blob, Utils.GetExcelName('Amortizacion_' + (this.summary.name || this.row.elementDescription || 'Subvencion')));
        this.notify.ok('Excel generado correctamente');
      })
      .catch(() => this.notify.error('No se pudo generar el Excel de amortización'));
  }
}
